export default "__VITE_ASSET__CvkFV5H2__"